exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".v3-dialog{display:flex;width:500px;max-width:500px;flex-direction:column;overflow-y:auto}.v3-dialog.overflow-visible{overflow-y:visible}.v3-dialog-large{width:970px;max-width:970px}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/postcss-loader/lib!./src/componentsv3/Dialog/components/DialogModal/style.css
 ** module id = 1193
 ** module chunks = 0
 **/